export const LOADING_START = 'LOADING_START';
export const LOADING_FINISHED = 'LOADING_FINISHED';